// extracted by mini-css-extract-plugin
export default {"appear":"lottie_appear__Lv4IG","appearActive":"lottie_appearActive__PaZJd"};